/* Inyecta la tira de "envío gratis" al pie del pop-up de compra rápida.
 *
 * El contenido del pop-up lo trae el tema por fetch cada vez que se abre, así
 * que no alcanza con ponerla una vez: hay que observar el contenedor y volver
 * a colgarla cuando se re-renderiza. La tira sale del mismo <template> que
 * emite el layout, de modo que es la misma pieza que la de las tarjetas.
 */
(function () {
  var TPL = 'sd-qa-ship';
  var MODAL = '#hdt-quick-add-modal';

  function pegarTira(modal) {
    var tpl = document.getElementById(TPL);
    if (!tpl) return;

    var inner = modal.querySelector('.hdt-dialog-modal__inner');
    if (!inner) return;

    // Va dentro del grupo de botones, que es el flex que ordena COMPRAR AHORA
    // y ANADIR AL CARRITO; asi la tira queda tercera sin trucos de posicion.
    var destino = inner.querySelector('.hdt-product-form__buttons')
      || inner.querySelector('.hdt-product__buy-button')
      || inner.firstElementChild;
    if (!destino) return;
    if (destino.querySelector('.sd-qa-ship')) return;

    var tira = tpl.content.firstElementChild;
    if (!tira) return;
    destino.appendChild(tira.cloneNode(true));
  }

  function enganchar() {
    var modal = document.querySelector(MODAL);
    if (!modal) return false;

    var inner = modal.querySelector('.hdt-dialog-modal__inner');
    if (!inner) return false;

    pegarTira(modal);
    new MutationObserver(function () { pegarTira(modal); })
      .observe(inner, { childList: true, subtree: true });
    return true;
  }

  function iniciar() {
    if (enganchar()) return;
    // El modal es perezoso: puede no existir todavia al cargar la pagina.
    var obs = new MutationObserver(function () {
      if (enganchar()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
